import { Button, Col, Form, Row } from "react-bootstrap";
import BackButton from "../../components/button/BackButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { Typography } from "../../components/utilities/Typhograpy";
import { FormProvider, useForm } from "react-hook-form";
import GlobalContext from "../../context/GlobalContext";
import { useContext, useEffect, useState } from "react";
import swal from "../../services/swalConfig";
import { useLocation } from "react-router-dom";
import InputWorkingDaysTime from "../../components/InputWorkingDaysTime";
import TimeZoneSelect from "../../components/TimeZoneSelect";
import { createSchedule, updateSchedule } from "../../api/ScheduleApi";

import { tr } from "../../i18n";
const ScheduleForm = () => {
  const { state } = useLocation();
  const data = state;

  const parsedSchedule = data?.schedule ? data.schedule : null;
  const { user, setLoading } = useContext(GlobalContext);
  const isEdit = Boolean(data?.id);
  const [timeZone, setTimeZone] = useState(null);

  const methods = useForm({
    defaultValues: {
      name: "",
      timeZone: null,
      schedule: null,
    },
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = methods;

  // jika edit, set data awal
  useEffect(() => {
    if (data) {
      reset({
        name: data.template_name || "",
        timeZone: { text: data.time_zone, id: data.time_zone },
        schedule: parsedSchedule ?? [],
      });
    }
  }, [data, reset]);

  const onSubmit = handleSubmit(async (input) => {
    setLoading(true);
    try {
      const payload = {
        ...input,
        company_id: user.workspace.company_id,
        id: isEdit && data.id,
      };

      let response;
      if (isEdit) {
        response = await updateSchedule(payload);
      } else {
        response = await createSchedule(payload);
      }

      if (response.status === 200) {
        if (!isEdit) {
          reset(methods.defaultValues);
        }
      }

      swal.fire({
        title: response.status === 200 ? tr("shared:success") : tr("common:errors.oops"),
        text: response.message,
        icon: response.status === 200 ? "success" : "error",
      });
    } catch (error) {
      swal.fire({
        title: tr("common:errors.oops"),
        text: tr("common:errors.generic"),
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  });

  return (
    <Row>
      <Col lg={12}>
        <div className="box-shadow">
          <FormProvider {...methods}>
            <Form onSubmit={onSubmit}>
              {/* Name */}
              <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="3">
                  <Typography variant="form">
                    {tr("shared:name")}{" "} <span className="text-danger">*</span>
                  </Typography>
                </Form.Label>
                <Col sm="9">
                  <Form.Control
                    {...register("name", { required: tr("attendance:name_is_required") })}
                    type="text"
                    placeholder={tr("attendance:e_g_default_employee_schedule")}
                  />
                  {errors.event && (
                    <small className="text-danger">{errors.name.message}</small>
                  )}
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-2">
                <Form.Label column sm="3">
                  <Typography variant="form">
                    {tr("shared:time_zone")}{" "} <span class="text-danger">*</span>
                  </Typography>
                </Form.Label>
                <Col sm="9">
                  <TimeZoneSelect
                    name="timeZone"
                    rules={{ required: tr("shared:time_zone_is_required") }}
                    defaultValue={
                      data?.time_zone
                        ? { id: data.time_zone, text: data.time_zone }
                        : null
                    }
                  />
                  {errors.timeZone ? (
                    <small className="text-danger">
                      {errors.timeZone.message}
                    </small>
                  ) : (
                    ""
                  )}
                </Col>
              </Form.Group>

              {/* Schedules input */}
              <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="3">
                  <Typography variant="form">
                    {tr("common:breadcrumb.schedule")}{" "} <span class="text-danger">*</span>
                  </Typography>
                </Form.Label>
                <Col sm="9">
                  <InputWorkingDaysTime
                    defaultValue={{ schedules: parsedSchedule }}
                  />
                  {errors.days ? (
                    Object.keys(errors.days).length > 0 ? (
                      <small className="text-danger">
                        {errors.days.message}
                      </small>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </Col>
              </Form.Group>

              {/* Action Buttons */}
              <div className="mt-5 d-flex justify-content-between">
                <BackButton url="/attendance?tab=schedules" />
                <Button type="submit" className="btn btn-primary">
                  <FontAwesomeIcon icon={faCheckCircle} />{" "}
                  {isEdit ? tr("attendance:update") : tr("attendance:create")}
                </Button>
              </div>
            </Form>
          </FormProvider>
        </div>
      </Col>
      <Col lg={5}></Col>
    </Row>
  );
};

export default ScheduleForm;
